import { cn } from '@utils/cn'

/** Linha de poupança anual com altura fixa para os preços não saltarem nem sobrepor outros elementos. */
export function AnnualSavingsLine({
  annual,
  children,
  className,
}: {
  readonly annual: boolean
  readonly children: string
  readonly className?: string
}) {
  return (
    <p
      className={cn(
        'mt-1 min-h-[1.375rem] text-sm transition-opacity duration-200',
        annual ? 'opacity-100' : 'opacity-0',
        className
      )}
      aria-hidden={!annual}
    >
      {children}
    </p>
  )
}
